import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-echarts-header",
  style: {"padding":"10px 24px 0 24px","height":"auto"}
}

import { PropType } from 'vue/dist/vue'
import { ref } from 'vue'
import AlarmDistribution from './AlarmDistribution.vue'


const __default__ = { name: 'AlarmPieCombine' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props
// 默认是异动类型 1 异动等级2
const distributionType = ref(1)


return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height, marginBottom: __props.marginBottom })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_radio_group, {
        value: distributionType.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((distributionType).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio_button, { value: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("异动类型分布")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio_button, { value: 2 }, {
            default: _withCtx(() => [
              _createTextVNode("异动等级分布")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode(AlarmDistribution, {
      appId: "cos_fbu",
      distributionType: distributionType.value.toString(),
      formState: props.formState
    }, null, 8, ["distributionType", "formState"])
  ], 4))
}
}

})